import { Button } from '@lms/ui/button';
import { Link } from 'react-router-dom';
import { useBrand } from '@/features/branding/brand-provider';

export function NotFound() {
  const { slug } = useBrand();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-4xl font-semibold">404</h1>
      <p className="text-muted-foreground">This page could not be found.</p>
      <Button asChild>
        <Link to={`/${slug}`}>Go home</Link>
      </Button>
    </div>
  );
}
